import React, { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { StepByStep } from '@gerdau/hefesto-mais-web';
import { Step } from '@gerdau/hefesto-mais-web/StepByStep/StepByStep.types';
import { ApplicationState } from '../../../../store';
import { EOrderSettingsRoutes } from '../OrderSettingsMvp/orderSettings.routes';
import { StepsContainer } from './styles';

const StepByStepComponent: React.FC = () => {
  const { pathname } = useLocation();
  const shoppingCart = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );

  const steps: Step[] = [
    { label: 'Selecionar produtos' },
    { label: 'Configurar carrinho' },
    { label: 'Revisar pedido' },
    { label: 'Finalizar pedido' }
  ];

  const [currentStep, setCurrentStep] = useState(0);
  const [cantShowSubHeader, setCantShowSubHeader] = useState(false);

  const updateCurrentStep = useCallback(() => {
    if (
      pathname.includes(EOrderSettingsRoutes.SEARCH_ITEMS) ||
      pathname.includes(EOrderSettingsRoutes.SPREADSHEET_UPLOAD) ||
      pathname.includes(EOrderSettingsRoutes.REPEAT_ORDER) ||
      pathname.includes(EOrderSettingsRoutes.CATALOG)
    ) {
      setCurrentStep(0);
    } else if (pathname.includes(EOrderSettingsRoutes.SHOPPING_CART)) {
      setCurrentStep(1);
    } else if (pathname.includes(EOrderSettingsRoutes.CHECKOUT)) {
      setCurrentStep(3);
    } else if (pathname.includes(EOrderSettingsRoutes.FINALIZE_ORDER)) {
      setCurrentStep(4);
    }
  }, [pathname, shoppingCart.createdOrders]);

  useEffect(() => {
    if (pathname) {
      updateCurrentStep();
      setCantShowSubHeader(pathname.includes(EOrderSettingsRoutes.CHOOSE));
    }
  }, [pathname, updateCurrentStep]);

  return (
    <StepsContainer className="ContainerStepByStep">
      {!cantShowSubHeader && (
        <StepByStep steps={steps} activeStep={currentStep}></StepByStep>
      )}
    </StepsContainer>
  );
};

export default StepByStepComponent;
